import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TopNavBarComponent } from './topnavbar.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthModule } from '../../../auth/auth.module';
import { B2BAngularMaterialModule } from '../angular.material/b2b.angular.material.module';

@NgModule({
    declarations: [TopNavBarComponent],
    imports: [BrowserModule, FormsModule, RouterModule, AuthModule, B2BAngularMaterialModule],
    exports: [TopNavBarComponent]
})

export class TopNavBarModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/topnavbar/topnavbar.module.ts